import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'

/**
 * Runs when the router meta.middleware is 'after-layout'
 * @param ctx
 */
export function afterEach(
  ctx: MiddlewareContext<App, RootState>) {
  const {store} = ctx

  if(!store || !store.state.layout) {
    throw new Error('[middleware layout] need to store')
  }

  store.commit('layout/updateRouting', false)
}
